import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa";
import "./Breadcrumbs.css";

const LABELS = {
  sms: "SMS Management",
  templates: "Templates",
  send: "Send SMS",
  logs: "SMS Logs",
  members: "Members",
  transactions: "Transactions",
  reports: "Reports",
  setup: "System Setup",
};

export default function Breadcrumbs() {
  const location = useLocation();
  const paths = location.pathname.split("/").filter(Boolean);

  return (
    <div className="breadcrumbs-container">
      <nav className="breadcrumbs">
        <Link to="/" className="crumb-link">Dashboard</Link>

        {paths.map((segment, index) => {
          const path = "/" + paths.slice(0, index + 1).join("/");
          const label = LABELS[segment] || segment;

          return (
            <span key={path} className="crumb-item">
              <FaChevronRight className="crumb-separator" />

              {index === paths.length - 1 ? (
                <span className="crumb-current">{label}</span>
              ) : (
                <Link to={path} className="crumb-link">
                  {label}
                </Link>
              )}
            </span>
          );
        })}
      </nav>
    </div>
  );
}